import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import * as R from 'ramda';
import getHistoryListDefaultHOCEnhance from '../../main/HistoryListDefaultHOC';
import HistoryList from '../../main/HistoryList';
import { useFunctionAsState } from '../../utilsReact';
import HistoryListSelectCmp from '../../main/HistoryListSelectCmp';
import TabsCD from '../../component/TabsCD';
import { store } from '../store';
import { useXProps } from '../../xprops';
import { MenuRHF } from '@cd/rhf';
import ApplyPaymentToInvoices from './ApplyPaymentToInvoices';
import GenerateMonthlyCharge from './GenerateCharge';
import GenerateCharge from './GenerateCharge';
import Divider from '@mui/material/Divider';
import { ROUTE_BASE } from './vars';
import TabMenuGroupCD from '../../component/TabMenuGroupCD';

const FINAL_ROUTE_BASE = `${ROUTE_BASE}/clients`;

const TABS = [
	{ name: 'SUBSCRITPION', route: 'subscription' },
	{ name: 'ALL', route: 'all' }
];

const getChargeData = ({ dispatch, selected }, type) =>
	R.prop(type, {
		subscription: {
			selectedPropName: 'id',
			noDataMessage: 'NO TRANSACTIONS',
			menuConfig: [
				{
					title: 'GENERATE MONTHLY CHARGE',
					name: 'generate_monthly_charge',
					fn: () => {
						dispatch({
							type: 'open dialog',
							dlgCmp: (
								<GenerateMonthlyCharge selected={selected} />
							)
						});
					}
				}
			]
		},
		all: {
			selectedPropName: 'id',
			noDataMessage: 'NO OUTSTANDING PAYMENTS',
			menuConfig: [
				{
					title: 'PAY',
					name: 'pay',
					fn: () => {
						dispatch({
							type: 'open dialog',
							dlgCmp: (
								<ApplyPaymentToInvoices selected={selected} />
							)
						});
					}
				}
			]
		}
	});

const ProductList = ({ data, match }) => {
	const [ProductList, setProductList] = useFunctionAsState(null);
	const [selected, setSelected] = useState([]);
	const { dispatch } = useContext(store);
	const { childRoute } = useXProps();
	const { clientID, type } = (match && match.params) || 0;
	const history = useHistory();

	const { noDataMessage, menuConfig, selectedPropName } = getChargeData(
		{ dispatch, selected },
		type
	);

	useEffect(() => {
		if (data) {
			const ChargeList = getHistoryListDefaultHOCEnhance({
				store,
				method: 'POST',
				url: `/get/client/${clientID}/products/${type}`,
				options: {
					body: JSON.stringify({}),
					reactQuery: { queryName: 'getClientProducts' }
				}
			})(HistoryList);

			setProductList(ChargeList);
			setSelected([]);
		}
	}, [data, type]);

	function onTabChange(tabValue) {
		history.replace(`${FINAL_ROUTE_BASE}/${clientID}/charge/${tabValue}`);
	}

	const setSelectedItems = R.compose(
		R.tap(setSelected),
		R.ifElse(
			() => type === 'paid',
			R.chain(([header, ...rest]) => (header.selected ? rest : [])),
			R.filter(R.propEq('selected', true))
		)
	);

	return (
		<>
			<TabMenuGroupCD>
				<TabsCD
					childRoute={childRoute}
					tabs={TABS}
					dark={true}
					onTabChange={onTabChange}
					initialValue={type}
				/>
				<MenuRHF
					disabled={selected.length === 0}
					menuConfig={menuConfig}
				/>
			</TabMenuGroupCD>

			{ProductList && (
				<ProductList
					noDataMessage={noDataMessage}
					total
					SelectCmp={
						<HistoryListSelectCmp
							selectedPropName={selectedPropName}
							onSelected={setSelectedItems}
							multi={false}
						/>
					}
				/>
			)}
			<Divider light />
			<br />
			{!R.isEmpty(selected) && (
				<GenerateCharge clientID={clientID} selected={selected} />
			)}
		</>
	);
};

export default ProductList;
